import { Injectable } from '@angular/core';
import { HttpService } from 'app/resources/services/http.service';
import { CiService } from 'app/resources/services/ci.service';
import { Router } from '@angular/router';

@Injectable()

export class SacService {

  public processando = false;
  public chamados = undefined;
  public chamadoSelecionado: any = undefined;

  constructor(public http: HttpService, public ciService: CiService, public router: Router) { }

  public atualizarChamados() {
    this.processando = true;
    this.chamados = undefined;

    this.http.pathRest().get('cartao/current/chamados/', true)
      .subscribe(
      sucesso => {
        this.chamados = sucesso.json();
        this.processando = false;
      });
  };

  public visualizarChamado(chamado) {
    this.processando = true;
    this.chamadoSelecionado = chamado;
    this.chamadoSelecionado.mensagens = [];

    this.http.pathRest().get('chamado/' + chamado.id + '/' + chamado.uuid + '/mensagens/', true)
      .subscribe(
      sucesso => {
        this.chamadoSelecionado.mensagens = sucesso.json();
        this.ciService.atualizarNaoLidas();
        this.processando = false;

      });
    this.router.navigate(['/sac/detalhe']);
  };

  public visualizarAnexos = function (chamado) {
    this.processando = true;
    this.router.navigate(['/sac/anexos']);

    this.chamadoSelecionado = chamado;
    this.chamadoSelecionado.anexos = [];

    this.http.pathRest().get('chamado/' + chamado.id + '/' + chamado.uuid + '/anexos/', true)
      .subscribe(
      sucesso => {
        this.chamadoSelecionado.anexos = sucesso.json();
        this.processando = false;
      });
  };
}



// WEBPACK FOOTER //
// ./src/app/resources/services/sac.service.ts